const STATUS_META = {
  processed: { label: "Processed", tone: "success" },
  pending: { label: "Pending", tone: "warning" },
  failed: { label: "Failed", tone: "danger" },
  not_processed: { label: "Not Processed", tone: "muted" },
};

export const PAYROLL_PAGE_SIZE_OPTIONS = [5, 10, 20];
export const TAX_REGIME_OPTIONS = ["Old Regime", "New Regime"];
export const PAYROLL_STATUS_OPTIONS = [
  { value: "all", label: "All Status" },
  { value: "processed", label: "Processed" },
  { value: "pending", label: "Pending" },
  { value: "failed", label: "Failed" },
  { value: "not_processed", label: "Not Processed" },
];

export function getCurrentMonthKey() {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

export function formatMonthHeading(monthKey) {
  const [year, month] = String(monthKey || getCurrentMonthKey())
    .split("-")
    .map((value) => Number(value));

  return new Intl.DateTimeFormat("en-IN", {
    month: "long",
    year: "numeric",
  }).format(new Date(year, month - 1, 1));
}

export function createPayrollDonutStyle(summary) {
  const processed = Number(summary?.processed || 0);
  const pending = Number(summary?.pending || 0);
  const failed = Number(summary?.failed || 0);
  const notProcessed = Number(summary?.notProcessed || 0);
  const total = Math.max(1, processed + pending + failed + notProcessed);

  const values = [
    ["#67c97c", (processed / total) * 100],
    ["#ffbf47", (pending / total) * 100],
    ["#ff6f6f", (failed / total) * 100],
    ["#b8beca", (notProcessed / total) * 100],
  ];

  let cursor = 0;
  const stops = values
    .filter(([, size]) => size > 0)
    .map(([color, size]) => {
      const stop = `${color} ${cursor}% ${cursor + size}%`;
      cursor += size;
      return stop;
    });

  return `conic-gradient(${stops.join(", ") || "#edf0f5 0% 100%"})`;
}

export function getPayrollStatusMeta(status) {
  return STATUS_META[status] || STATUS_META.not_processed;
}

export function parsePayrollCsv(text) {
  return String(text || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .slice(1)
    .map((line) => {
      const parts = line.split(",").map((part) => part.trim().replace(/^"|"$/g, ""));

      return {
        employeeId: parts[0] || "",
        monthKey: parts[1] || "",
        status: parts[2] || "",
        basicSalary: parts[3] || "",
        houseRentAllowance: parts[4] || "",
        conveyanceAllowance: parts[5] || "",
        specialAllowance: parts[6] || "",
        providentFund: parts[7] || "",
        professionalTax: parts[8] || "",
        incomeTax: parts[9] || "",
        payFrequency: parts[10] || "",
        taxRegime: parts[11] || "",
        paymentDateKey: parts[12] || "",
      };
    })
    .filter((row) => row.employeeId);
}

export function downloadPayrollCsv(fileName, rows) {
  const csv = rows
    .map((row) =>
      row
        .map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`)
        .join(",")
    )
    .join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}

export function triggerBlobDownload(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}
